import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Top from "./pages/Top";
import Story from "./pages/Story";
import Characters from "./pages/Characters";
import {System, Overview, SystemPage, Memories, Areas, Spirits, BirdSpirit} from "./pages/System";
import Products from "./pages/Products";
import Media from "./pages/Media";
import GA from "./utility/GA";
import ScrollToTop from "./utility/ScrollToTop";
import { useState } from "react";
import './styles/app.scss'
import JumpScareGate from "./components/JumpScareGate";
import Gimmick from "./components/Gimmick";
import NavBar from "./components/NavBar";
import Footer from "./Footer"
import Flashlight from "./components/Flashlight";
import ReactHowler from "react-howler";
import BGM from './sound/bgm.mp3';

function App() {

  const [isPlaying, setIsPlaying] = useState(true)
  const setMusic = () => {
    setIsPlaying(!isPlaying)
  }
  const [start, changeStart] = useState(false)
  const startWebsite = () => {
    changeStart(true)
  }

  if (start) {
    <div className="App">
    <Router basename={process.env.PUBLIC_URL}>
        <GA GA="G-LHVHBKPDXN" UA="UA-199221440-12"/> 
        <JumpScareGate startWebsite={startWebsite}/>
        <ReactHowler src={BGM} playing={isPlaying} volume={0.5} loop={true}/>
    </Router>
  </div>
  }
  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
          <GA GA="G-LHVHBKPDXN" UA="UA-199221440-12"/> 
          <JumpScareGate startWebsite={startWebsite}/>
          <NavBar setMusic={setMusic} isPlaying={isPlaying}/>
          <Flashlight/>
          <Gimmick setMusic={setMusic} isPlaying={isPlaying}/>
          <ReactHowler src={BGM} playing={isPlaying} volume={0.5} loop={true}/>
          <Routes>
            <Route exact path='/' element={<Top setMusic={setMusic} isPlaying={isPlaying}/>} />
            <Route exact path='/story' element={<Story/>} />
            <Route exact path='/characters' element={<Characters/>} />
            <Route exact path='/system' element={<System/>}>
              <Route exact path='' element={<Overview/>}/>
              <Route exact path='1' element={<Overview/>}/>
              <Route exact path='2' element={<SystemPage/>}/>
              <Route exact path='3' element={<Memories/>}/>
              <Route exact path='4' element={<Areas/>}/>
              <Route exact path='5' element={<Spirits/>}/>
              <Route exact path='6' element={<BirdSpirit/>}/>
            </Route>
            <Route exact path='/products' element={<Products/>} />
            <Route exact path='/media' element={<Media/>} />
          </Routes>
          <Footer/>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
